import Base from '@/resources/Base'

export default class NetworkInfo extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/NetworkInfo.js